import { FC } from "react";
import { CommonIconProps } from "./types";

const Stop: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-stop"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="8" y="8" width="8" height="8" rx="2" />
    </svg>
  );
};

export default Stop;
